import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/egalite-incluipcd/egalite-incluipcd/apps/incluipcd/src/blocks/QuemSomos/PilaresCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/egalite-incluipcd/egalite-incluipcd/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/egalite-incluipcd/egalite-incluipcd/node_modules/next/dist/client/link.js");
